import {trpc} from '@common-web/lib/trpc';
import {cn} from '@common-web/lib/utils';

// One blue scale: lighter early, solid once active, so the fill shows how far along a group is.
const EARLY_TONES = [
  'bg-blue-50 text-blue-700',
  'bg-blue-100 text-blue-800',
  'bg-blue-200 text-blue-900',
];
const FINAL_TONE = 'bg-blue-900 text-white';

// The phase as a chip, shaded by its place in the order the task lists define.
export function PhaseBadge({phase}: {phase: string}) {
  const {data} = trpc.internal.groupPipeline.filterOptions.useQuery();
  const phases = data?.phases ?? [];
  const index = phases.indexOf(phase);
  const last = phases.length - 1;
  const tone =
    index >= 0 && index === last
      ? FINAL_TONE
      : EARLY_TONES[
          index <= 0 ? 0 : Math.round((index * (EARLY_TONES.length - 1)) / Math.max(1, last - 1))
        ];

  return (
    <span
      aria-label={index >= 0 ? `${phase}, phase ${index + 1} of ${phases.length}` : phase}
      className={cn(
        'inline-flex shrink-0 items-center whitespace-nowrap rounded-md px-2 py-0.5 text-xs font-bold',
        tone,
      )}
    >
      {phase}
    </span>
  );
}
